import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { RequiresAccess } from '@interxfi/design-system/access-context';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { Button } from '@interxfi/design-system/components/button/button';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table';
import PlusIcon from '@interxfi/design-system/icons/react/icon-plus';
import { PageTabRail } from '../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import { TrfSessionRegisterDrawer } from '../../../../../../../../../../features/trf/session/trf-session-register-drawer';
import { TrfSessionsTable } from '../../../../../../../../../../features/trf/session/trf-sessions-table';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trade/trf-session/_trf-session/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingOperationsTrade,
      label: 'TRF FIX Sessions',
      order: 3,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingOperationsTrade>,
  head: () => getPageHead('TRF FIX Sessions'),
  component: TrfSessionList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          <RequiresAccess write>
            <TrfSessionRegisterDrawer trigger={<Button affixIcon={<PlusIcon aria-hidden />} aria-label="Register TRF FIX Session" size="small" />} />
          </RequiresAccess>
          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.ClearingOperationsTrade}
    />
  );
}

function TrfSessionList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <TrfSessionsTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
